// extracted by mini-css-extract-plugin
module.exports = {"inherit":"getFontWeight_inherit__1D_wG","regular":"getFontWeight_regular__160up","medium":"getFontWeight_medium__18RRN","bold":"getFontWeight_bold__27smd"};